/*
 * File: PatientSearchPage.js
 * Project: mp-mobile-app
 *
 * Created by Dillon Neukirch on 07/23/2020
 *
 * Copyright (c) 2020 MacPractice, Inc. All rights reserved.
 *
 * Description:
 */
import React from "react";
import { observer, PropTypes } from "mobx-react";
import UIProgress from "components/ui/UIProgress";
import PatientSearch from "../components/PatientSearch";
import SearchResults from "../components/SearchResults";
import PatientSearchStore from "../store/Store";
import { StoreContext } from "utils/useStore";

class PatientSearchPage extends React.Component {
  static contextType = StoreContext;

  get searchStore() {
    return this.context.getStore(PatientSearchStore);
  }

  componentDidMount() {
    this.props.history.listen((location, action) => {
      if (action === "PUSH" && location.pathname === "/patients") {
        this.searchStore.clearSearch();
      }
    });
  }

  onResultClick = patient => {
    this.searchStore.clearSearch();
    this.props.history.push("/patients/" + patient.patientId + "/patient_home");
  };

  render() {
    let { loading, patients } = this.searchStore;
    return (
      <div>
        <PatientSearch store={this.searchStore} />
        {loading && <UIProgress />}
        {!loading && patients && (
          <SearchResults
            parentCallBack={this.onResultClick}
            patients={this.searchStore.sortedPatients}
            hasSearched={this.searchStore.searched}
          />
        )}
      </div>
    );
  }
}

PatientSearchPage.propTypes = {
  history: PropTypes.object
};

export default observer(PatientSearchPage);
